// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3dasX","errors":"Errors_errors__2yTCt"};